import { valueOf } from "@encoway/c-services-js-client"

import { Constants } from "./constants"
import { getProductInfo } from "./helper"
import {
    IImages,
    IVisualizationEditorSettings,
    IVisualizationExtensionRendering,
    IVisualizationServer
} from "./visualizationService.types"

export async function determineRenderSettings(
    visualization: IVisualizationServer,
    productId: string,
    visSettings: IVisualizationEditorSettings
): Promise<object | undefined> {
    const productInfo = await getProductInfo(visualization, productId)
    if (!productInfo) {
        return
    }

    const value = valueOf(productInfo, Constants.Characteristic.RenderSettings)
    if (!value) {
        return
    }

    const renderSettings = typeof value === "string" && JSON.parse(value)
    const hasViews =
        // eslint-disable-next-line no-prototype-builtins
        renderSettings.hasOwnProperty("view") &&
        ((Array.isArray(renderSettings.view) &&
            renderSettings.view.length > 0) ||
            (typeof renderSettings.view === "string" &&
                renderSettings.view !== ""))

    if (renderSettings && hasViews) {
        renderSettings.lights = renderSettings.lights || visSettings.ui?.lights
        return renderSettings
    } else {
        throw new Error()
    }
}

export async function render(
    visualization: IVisualizationServer,
    settings: any
): Promise<IImages | undefined> {
    const renderingExtension = (await visualization.useExtension(
        Constants.Extension.Rendering,
        visualization.version,
        visualization.cloud.token
    )) as IVisualizationExtensionRendering

    const images = await renderingExtension.renderImages(
        visualization.cloud,
        settings,
        { output: "json" }
    )

    return Object.keys(images).reduce((accImages, key: string) => {
        const imageUrl = images[key]
        accImages[key] = imageUrl.split(",")[1]

        return accImages
    }, {} as any)
}
